document.addEventListener('DOMContentLoaded', function () {
    const sendButton = document.getElementById("sendbutton");

    sendButton?.addEventListener("click", sendButtonAbschicken);

    function getInput(selector: string): string {
        const e = (document.querySelector(selector) as HTMLInputElement)
        if (e) return e.value
        return e
    }

    async function sendButtonAbschicken() {
        const obj = {
            Name: getInput('input[name="name"]'),
            Domain: getInput('input[name="domain"]'),
            Email: getInput('input[name="email"]'),
            Company: getInput('input[name="company"]'),
            Language: sendButton?.dataset.lang
        }
        const splitted = obj.Email.split("@")
        if (splitted.length != 2) {
            alert("Please enter a valid email address!")
            return
        }
        if (splitted[1].toLowerCase() != obj.Domain.toLowerCase()) {
            alert("Target domain must be identical to the email domain!")
            return
        }
        try {
            const res = await fetch('https://de.rasotec.com/api/infoscan', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(obj),
            })
            if (res.ok) {
                openPopup()
                return
            }
            alert("Error");
        } catch (error) {
            alert("Error");
        }
    }

    function openPopup(): void {
        const popupOverlay = document.getElementById('popupOverlay');
        if (popupOverlay) {
            popupOverlay.classList.replace('displaynone', 'displayflex');
            document.body.style.overflow = 'hidden';
        }
    }
})